<template>
  <v-container class="pa-0 pb-13" fluid>
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />

    <!-- Layout paginado -->
    <PaginatedLayout :items="branches" @update-page="updatePage" class="pb-15">
      <!-- Header -->
      <template v-slot:header>
        <DeltiaCard>
          <!-- Columna para el título -->
          <v-col cols="12" md="7" class="mb-6">
            <p class="display-1 font-weight-bold mb-0 pb-0">Sucursales</p>
          </v-col>
          <!-- Columna para el botón de agregar sucursal -->
          <v-col cols="12" md="5" class="mb-6">
            <NewBranch
              @new-branch="onNewBranch"
              @branch-error="onBranchError"
            />
          </v-col>
        </DeltiaCard>
      </template>
      <!-- Sucursales -->
      <template v-slot:items>
        <!-- Pantalla de carga -->
        <LoadingLayout v-if="isLoading">
          <LinearLoading>
            Cargando sucursales
          </LinearLoading>
        </LoadingLayout>
        <!-- Items -->
        <template v-else>
          <!-- Fila única para indicar qué datos hay -->
          <v-row
            v-if="branches.docs.length > 0"
            no-gutters
            class="ml-7 mr-7 mb-2 mt-10 hidden-sm-and-down"
          >
            <!-- Columna para el nombre -->
            <v-col cols="12" md="3">
              <p class="font-weight-medium mb-1 text--disabled">
                Nombre
              </p>
            </v-col>
            <!-- Tipo de usuario -->
            <v-col cols="12" md="6">
              <p class="font-weight-medium mb-1 text--disabled">Dirección</p>
            </v-col>
            <!-- Columna para la fecha -->
            <v-col cols="12" md="3">
              <p class="font-weight-medium mb-1 text--disabled">Agregada</p>
            </v-col>
            <!-- Columna para los ajustes -->
            <v-col cols="12" md="1" align="center" justify="center"></v-col>
          </v-row>
          <!-- Mostrar item para cada sucursal -->
          <BranchItem
            v-for="item in branches.docs"
            :key="item._id"
            :date="item.created_at"
            :name="item.name"
            :address="item.location.address"
            :branchId="item._id"
            @branch-updated="onBranchUpdated"
            @branch-deleted="onBranchDeleted"
            @branch-error="onBranchError"
          />
        </template>
      </template>
    </PaginatedLayout>
  </v-container>
</template>

<script>
// Importar servicios
import BranchesServices from "@/services/BranchesServices";

// Importar dependencias
import { mapGetters } from "vuex";

// Importar componentes
import PaginatedLayout from "@/layouts/PaginatedLayout";
import LinearLoading from "@/components/Loading/Linear";
import LoadingLayout from "@/layouts/LoadingLayout";
import SnackbarMessage from "@/components/SnackbarMessage";
import BranchItem from "@/components/branches/BranchItem";
import NewBranch from "@/components/branches/modals/NewBranch";
import DeltiaCard from "@/components/DeltiaCard";

export default {
  components: {
    LinearLoading,
    LoadingLayout,
    PaginatedLayout,
    SnackbarMessage,
    BranchItem,
    NewBranch,
    DeltiaCard
  },
  data: function() {
    return {
      branches: { docs: [] },
      isLoading: true
    };
  },
  mounted: async function() {
    await this.updatePage();
  },
  methods: {
    updatePage: async function(page = 1) {
      try {
        // Mostrar pantalla de carga
        this.isLoading = true;

        // Obtener sucursales
        this.branches = await BranchesServices.getBranchesByBusinessId(
          this.getProfile.business_id,
          page
        );

        // Ocultar pantalla de carga
        this.isLoading = false;
      } catch (err) {
        // Mostrar error
        this.onBranchError(err.message);
      }
    },
    onNewBranch: async function() {
      // Mostrar mensaje de éxito
      this.$refs.snackbar.showSuccessMessage("Sucursal creada con éxito");

      // Actualizar sucursales
      await this.updatePage();
    },
    onBranchError: function(errorMessage) {
      // Mostrar error
      this.$refs.snackbar.showError(errorMessage);
    },
    onBranchUpdated: async function() {
      // Mostrar mensaje de éxito
      this.$refs.snackbar.showSuccessMessage("Sucursal modificada con éxito");

      // Actualizar sucursales
      await this.updatePage();
    },
    onBranchDeleted: async function() {
      // Mostrar mensaje de éxito
      this.$refs.snackbar.showSuccessMessage("Sucursal eliminada con éxito");

      // Actualizar sucursales
      await this.updatePage();
    }
  },
  computed: {
    ...mapGetters(["getProfile"])
  }
};
</script>
